<template>
  <b-row>
    <b-col>
      <!-- Form category name -->
      <b-row>
        <b-col cols="12">
          <b-form-group
            :label="$lang.enum_caption"
            label-for="category_selected"
            :label-cols="12"
          >
            <!-- <requiredComponent slot="label" :label="$lang.enum_caption" :rules="$v.enum_caption.$params" :showColor="true" :colorValue="bgColorValue" /> -->
            <requiredComponent
              slot="label"
              :label="$lang.enum_caption"
              :rules="$v.enum_caption.$params"
            />
            <b-form-input
              id="name"
              type="text"
              v-model="$v.enum_caption.$model"
              :autocomplete="$lang.caption"
              :disabled="isLoading"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            :label="$lang.choose_color"
            label-for="color_selected"
            :label-cols="12"
          >
            <div
              v-for="(color, key) in colors"
              :key="key"
              :style="{ backgroundColor: color.bgColor }"
              class="circle-60"
              @click="changeColor(color.bgColor, key)"
            >
              <span v-if="key == active">
                <i
                  class="fa fa-check fa-lg text-success icon-cheched-color"
                  aria-hidden="true"
                ></i>
              </span>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Form button -->
      <b-button
        type="submit"
        size="md"
        variant="success"
        class="my-1 float-right"
        :disabled="isLoading"
        @click.prevent="saveEnum"
      >
        <template v-if="isLoading">
          <b-spinner small></b-spinner>
          {{ $lang.inSubmit }}
        </template>
        <template v-else>
          {{ $lang.submit }} <i class="fa fa-check"></i
        ></template>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {pathOr} from 'ramda'
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  validations: {
    enum_caption: {
      required,
    },
    enum_color: {},
  },
  name: "add-enum",
  props: {
    // The name of the enum in api, String,required
    categoryName: String,
  },
  data() {
    return {
      enum_caption: "",
      enum_color: null,
      color: "red",
      parent_id: 0,
      isLoading: false,
      active: 0,
      bgColorValue: "#908787",
      colors: [
        {
          bgColor: "red",
        },
        {
          bgColor: "blue",
        },
        {
          bgColor: "white",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["getAllEnumeration"]),
    changeColor(color, key) {
      this.bgColorValue = color;
      this.active = key;
    },
    // @vuese
    // Used to emit enum saved
    // @arg No arguement needed
    // Fire when the enum is saved via api
    saveEnum() {
      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }

      let payload = {
        parent_id: this.parent_id,
        enum_caption: this.enum_caption,
        category_name: this.categoryName,
        color: this.bgColorValue,
      };
      this.$httpService
        .post(this.$config.api_url + this.$config.resources.enum, payload)
        .then((response) => {
          const data = pathOr([], ["data", "data"], response);
          const enumData = {
            text: pathOr(null, ["enum_caption"], data),
            value: pathOr(null, ["enum_id"], data),
          };
          this.$emit("saved", enumData);
          this.$notify.success(response.data.message);
          this.getAllEnumeration()
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          this.isLoading = false;
        });
    }
  }
};
</script>

<style>
.circle-60 {
  width: 35px;
  height: 35px;
  border-radius: 60%;
  margin: 0 5px;
  display: inline-flex;
  position: relative;
  cursor: pointer;
  border: 1px solid black;
}

.icon-cheched-color {
  position: absolute;
  right: 7px;
  top: 10px;
  color: white;
}

.overlay-checked {
  border-radius: 60%;
  width: 35px;
  height: 35px;
  border-radius: 60%;
  background-color: #000000bd;
}
</style>
